import { __assign } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { components } from 'react-select';
import Spinner from '@atlaskit/spinner';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import DownIcon from '@atlaskit/icon/glyph/chevron-down';
export var ClearIndicator = function (props) { return (jsx(components.ClearIndicator, __assign({}, props),
    jsx(SelectClearIcon, { size: "small", primaryColor: "inherit", label: "clear" }))); };
export var DropdownIndicator = function (props) { return (jsx(components.DropdownIndicator, __assign({}, props),
    jsx(DownIcon, { label: "open" }))); };
export var LoadingIndicator = function (props) { return (jsx("div", __assign({ css: props.getStyles('loadingIndicator', props) }, props.innerProps),
    jsx(Spinner, { size: "small" }))); };
//# sourceMappingURL=indicators.js.map